export default "<p>cookie works!</p>\r\n"